import "./src/styles/global.css"
import "@fontsource/comfortaa/400.css"
import "@fontsource/comfortaa/600.css"
import "@fontsource/comfortaa/700.css"
import wrapWithProvider from './src/wrap-with-provider';

export const wrapRootElement = wrapWithProvider;
